import { RemoteLoadAccountMemberList } from '@/javascript/data/usecases'
import { LoadAccountMemberList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadAccountMemberList = (): LoadAccountMemberList =>
  new RemoteLoadAccountMemberList(makeApiUrl('/account_members'), makeCurrentAccountHttpClientDecorator())
